const CREDIT_CARD = 'creditCard';
const DUMMY_PAYMENT = 'dummyPayment';
const REPLACEMENT_PAYMENT = 'replacementPayment';
const OFFLINE_PAYMENT = 'Offline Payment';
const STRIPE_CARD = 'card';
const SWAG_PAYMENT = 'SWAG';
const DEFAULT_PAYMENT_METHOD = CREDIT_CARD;
const NET_15 = 'NET_15';
const NET_30 = 'NET_30';
const NET_45 = 'NET_45';
const NET_60 = 'NET_60';
const UPFR_50_NET_15 = 'UPFR_50_NET_15';
const UPFR_50_NET_30 = 'UPFR_50_NET_30';
const ACH = 'ACH';
const CREDITS = 'inventoryCredits';

// Used on order pages and Activity pages for example
export const CREDITS_COMMON_TITLE = 'Credits';
var PaymentScreen = /*#__PURE__*/function (PaymentScreen) {
  PaymentScreen[PaymentScreen["existedCardsList"] = 0] = "existedCardsList";
  PaymentScreen[PaymentScreen["preselectedCard"] = 1] = "preselectedCard";
  PaymentScreen[PaymentScreen["enterManually"] = 2] = "enterManually";
  PaymentScreen[PaymentScreen["payByCredits"] = 3] = "payByCredits";
  return PaymentScreen;
}(PaymentScreen || {});
const PAYMENT_METHODS = [{
  name: 'Credit card',
  code: CREDIT_CARD,
  id: 1,
  hasDuration: false,
  description: 'CREDIT_CARD description'
}, {
  name: 'Net 15',
  code: NET_15,
  dutyDaysCount: 15,
  id: 2,
  hasDuration: true,
  description: 'NET_15 description',
  prepaymentPercentageAmount: 0
}, {
  name: 'Net 30',
  code: NET_30,
  dutyDaysCount: 30,
  id: 3,
  hasDuration: true,
  description: 'NET_30 description',
  prepaymentPercentageAmount: 0
}, {
  name: 'Net 15 (50% upfront)',
  code: UPFR_50_NET_15,
  dutyDaysCount: 15,
  id: 4,
  hasDuration: true,
  description: 'UPFR_50_NET_15 description',
  prepaymentPercentageAmount: 50
}, {
  name: 'Net 30 (50% upfront)',
  code: UPFR_50_NET_30,
  dutyDaysCount: 30,
  id: 5,
  hasDuration: true,
  description: 'UPFR_50_NET_30 description',
  prepaymentPercentageAmount: 50
}, {
  name: ACH,
  code: ACH,
  id: 6,
  hasDuration: true,
  description: 'ACH description',
  prepaymentPercentageAmount: 100
}, {
  name: 'Dummy payment',
  code: DUMMY_PAYMENT,
  id: 7,
  hasDuration: false,
  description: 'Dummy payment description',
  disallowSelectForUser: true
}, {
  name: 'Inventory Credits',
  code: CREDITS,
  id: 8,
  hasDuration: false,
  description: 'credits description'
}, {
  name: 'Replacement payment',
  code: REPLACEMENT_PAYMENT,
  id: 9,
  hasDuration: false,
  description: 'Replacement payment description',
  disallowSelectForUser: true
}, {
  name: 'Net 45',
  code: NET_45,
  dutyDaysCount: 45,
  id: 10,
  hasDuration: true,
  description: 'NET_45 description',
  prepaymentPercentageAmount: 0
}, {
  name: 'Net 60',
  code: NET_60,
  dutyDaysCount: 60,
  id: 11,
  hasDuration: true,
  description: 'NET_60 description',
  prepaymentPercentageAmount: 0
}];
export const PAYMENT_METHODS_LABELS = {
  [CREDIT_CARD]: 'Credit Card',
  [ACH]: ACH
};
export { STRIPE_CARD, CREDIT_CARD, DUMMY_PAYMENT, REPLACEMENT_PAYMENT, OFFLINE_PAYMENT, NET_15, NET_30, NET_45, NET_60, UPFR_50_NET_15, UPFR_50_NET_30, ACH, DEFAULT_PAYMENT_METHOD, PAYMENT_METHODS, CREDITS, SWAG_PAYMENT, PaymentScreen };
export let GIVEAWAY_PAY_POPUP_FLOW = /*#__PURE__*/function (GIVEAWAY_PAY_POPUP_FLOW) {
  GIVEAWAY_PAY_POPUP_FLOW["SAVE_CARD"] = "SAVE_CARD";
  GIVEAWAY_PAY_POPUP_FLOW["PAY_BY_LINK"] = "PAY_BY_LINK";
  return GIVEAWAY_PAY_POPUP_FLOW;
}({});
export let PaymentMethodFrequency = /*#__PURE__*/function (PaymentMethodFrequency) {
  PaymentMethodFrequency["ONE_TIME"] = "ONE_TIME";
  PaymentMethodFrequency["INFINITE"] = "INFINITE";
  return PaymentMethodFrequency;
}({});
export const PAYMENT_DURATION = [{
  name: 'One time',
  code: PaymentMethodFrequency.ONE_TIME,
  id: 0
}, {
  name: 'Infinite',
  code: PaymentMethodFrequency.INFINITE,
  id: 1
}];
export const POSSIBLE_PAYMENT_METHODS = PAYMENT_METHODS.reduce((acc, method) => {
  acc[method.code] = method.name;
  return acc;
}, {});